export default {
  'app.dashboard.mqttServer': '当前服务器',
  'app.dashboard.summary': 'FBox应用情况',
  'app.dashboard.summary.total': 'FBox总数',
  'app.dashboard.summary.online': 'FBox在线数',
  'app.box.prompt.delete': '确定要移除设备 {boxNos}',
  'app.box.prompt.clean': '确定要清除设备 {boxNos} 的配置？',
  'app.box.prompt.cleanSuccess': '设备配置清除成功。',
  'app.box.prompt.cleanFailed': '设备配置清除失败。',
  'app.box.prompt.reboot': '确定要重启设备 {boxNos}',
  'app.box.prompt.typeError': '批量升级仅支持同类型设备。',
  'app.box.prompt.offlineError': '设备{boxNos}不在线。',
  'app.box.prompt.connectionSuccess': '盒子{boxNo}连接配置更新成功。',
  'app.box.prompt.connectionFailed': '盒子{boxNo}连接配置更新失败。',
  'app.box.prompt.timeSuccess': '盒子{boxNo}时钟配置更新成功。',
  'app.box.prompt.timeFailed': '盒子{boxNo}时钟配置更新失败。',
  'app.box.table.index': '序号',
  'app.box.table.alias': 'FBox名称',
  'app.box.table.boxNo': 'FBox序列号',
  'app.box.table.connectionState': 'FBox状态',
  'app.box.table.templateState': '下发状态',
  'app.box.table.boxType': '型号',
  'app.box.table.templateName': '关联模板',
  'app.box.table.plcCount': '设备数量',
  'app.box.table.variableCount': '变量数量',
  'app.box.table.networkType': '联网方式',
  'app.box.table.lastOffline': '离线时间',
  'app.box.table.operation': '操作',
  'app.box.table.operation.contact': '关联',
  'app.box.table.operation.detail': '详情',
  'app.box.table.operation.delete': '删除',
  'app.box.table.operation.edit': '编辑',
  'app.box.toolbar.keyword': '搜索FBox名称、序列号',
  'app.box.toolbar.remark': '模糊搜索备注',
  'app.box.toolbar.import': '导入FBox',
  'app.box.toolbar.cancel': '取消',
  'app.box.toolbar.select': '选择',
  'app.box.toolbar.checkAll': '全选/反选',
  'app.box.toolbar.batch': '批量操作',
  'app.box.toolbar.batch.delete': '删除设备',
  'app.box.toolbar.batch.firmware': '固件更新',
  'app.box.toolbar.batch.template': '关联模板',
  'app.box.toolbar.batch.connection': '更改连接',
  'app.box.toolbar.batch.time': '更改时钟',
  'app.box.toolbar.batch.tunnel': '透传',
  'app.box.toolbar.batch.reboot': '重启',
  'app.box.toolbar.batch.clean': '清除配置',
  'app.box.toolbar.updateTemplate': '更新模板',
  'app.box.toolbar.batchRetry': '批量重试',
  'app.box.toolbar.upgradeFirmware': '更新固件',
  'app.box.toolbar.connectionState': 'FBox状态选择',
  'app.box.toolbar.templateState': '下发状态选择',
  'app.box.toolbar.clear': '清空',
  'app.box.toolbar.search': '搜索',
  'app.box.toolbar.moreFilter': '更多筛选',
  'app.box.toolbar.filter.boxType': '型号选择',
  'app.box.toolbar.filter.templateName': '关联模板',
  'app.box.toolbar.filter.remark': '搜索标签',
  'app.box.toolbar.filter.ok': '确定',
  'app.box.toolbar.filter.cancel': '取消',
  'app.box.import.selectFile': '选择文件',
  'app.box.import.selectFile.placeholder': '请选择',
  'app.box.import.selectFile.message': '请选择文件',
  'app.box.import.downloadTemplate': '下载模板',
  'app.box.import.boxSubType': '上网方式',
  'app.box.import.index': '序号',
  'app.box.import.alias': 'FBox名称',
  'app.box.import.boxNo': 'FBox序列号',
  'app.box.import.boxNo.message': 'FBox序列号不能为空。',
  'app.box.import.userPassword': 'FBox密码',
  'app.box.import.userPassword.message': 'FBox密码不能为空。',
  'app.box.import.tags': '标签',
  'app.box.import.ip': 'IP地址',
  'app.box.import.ip.message': 'IP地址不能为空',
  'app.box.import.natIp': 'IP地址',
  'app.box.import.search': '搜索',
  'app.box.import.find': '查找',
  'app.box.import.add': '添加',
  'app.box.import.importType': '导入类型',
  'app.box.import.operation': '操作',
  'app.box.import.exists': '{boxNo}，已被添加',
  'app.box.detail.title': 'FBox详情',
  'app.box.detail.variable.title': '变量详情',
  'app.box.detail.variable.pushStatus': '当前推送状态',
  'app.box.detail.variable.pushStatus.on': '开启',
  'app.box.detail.variable.pushStatus.off': '关闭',
  'app.box.detail.variable.value.title': '设置监控点数据数值',
  'app.box.detail.variable.value': '新值',
  'app.box.detail.variable.value.required': '值不能为空',
  'app.box.detail.variable.value.required.range': '数据超出范围({min} ~ {max})',
  'app.box.detail.variable.value.string': '请输入字符串值',
  'app.box.detail.variable.value.decimal': '请输入十进制数字',
  'app.box.detail.variable.value.hex': '请输入十六进制数字',
  'app.box.detail.variable.value.binary': '请输入二进制数字',
  'app.box.detail.variable.value.bcd': '请输入BCD码',
  'app.box.detail.basic.title': '参数配置',
  'app.box.detail.basic.alias': '设备别名',
  'app.box.detail.basic.boxNo': '序 列 号',
  'app.box.detail.basic.connectionState': '在线状态',
  'app.box.detail.basic.contactTemplate': '关联模板',
  'app.box.detail.basic.networkType': '联网方式',
  'app.box.detail.basic.carrier': '运 营 商',
  'app.box.detail.basic.tags': '设备标签',
  'app.box.detail.basic.tags.add': '添加',
  'app.box.detail.basic.advanced': '高级功能',
  'app.box.detail.system.title': '系统设置',
  'app.box.detail.audit.title': '操作记录',
  'app.box.detail.audit.clear': '清除',
  'app.box.detail.audit.search': '搜索',
  'app.box.detail.audit.index': '序号',
  'app.box.detail.audit.creationTime': '时间',
  'app.box.detail.audit.content': '详情',
  'app.box.detail.audit.creator': '用户名',
  'app.box.detail.audit.type': '操作类型',
  'app.box.detail.audit.type.0': '全部',
  'app.box.detail.audit.type.1': '模板下发',
  'app.box.detail.audit.type.2': '固件升级',
  'app.box.detail.audit.type.3': '网络设置',
  'app.box.detail.audit.type.4': '更新时间',
  'app.box.detail.audit.type.5': '更新APN',
  'app.box.detail.audit.type.6': '启用推送',
  'app.box.detail.audit.type.7': '重启设备',
  'app.box.detail.audit.type.8': '连接设置',
  'app.box.detail.audit.type.9': '报警使能',
  'app.box.detail.audit.type.10': '网络配置',
  'app.box.detail.audit.type.11': '出厂设置',
  'app.box.detail.audit.type.12': '设置模式',
  'app.box.detail.audit.type.13': '变量写值',
  'app.box.detail.audit.type.14': '日志配置',
  'app.box.detail.audit.type.15': '日志上传',
  'app.box.detail.audit.type.16': '清除配置',
  'app.box.detail.audit.template.1': '模板名称：【{templateName}】',
  'app.box.detail.audit.template.2': '固件版本：【{version}】',
  'app.box.detail.audit.template.3': '设置联网方式/设置Wan参数/设置WiFi参数',
  'app.box.detail.audit.template.4': '设置时钟参数',
  'app.box.detail.audit.template.5': '设置APN参数',
  'app.box.detail.audit.template.6': '推送状态：【{enableItemPush}】',
  'app.box.detail.audit.template.7': ' ',
  'app.box.detail.audit.template.8': '设置连接参数',
  'app.box.detail.audit.template.9': '报警使能：【{enableItemPush}】 ',
  'app.box.detail.audit.template.10': ' ',
  'app.box.detail.audit.template.11': '恢复出厂设置',
  'app.box.detail.audit.template.12': '设置连接参数',
  'app.box.detail.audit.template.13': ' ',
  'app.box.detail.audit.template.14': ' ',
  'app.box.detail.audit.template.15': ' ',
  'app.box.detail.audit.template.16': ' ',
  'app.box.detail.connection.title': '连接设置',
  'app.box.detail.logs.title': '上线记录',
  'app.box.detail.logs.index': '序号',
  'app.box.detail.logs.content': '内容',
  'app.box.detail.logs.timestamp': '时间',
  'app.box.detail.logs.action.0': '离线',
  'app.box.detail.logs.action.1': '上线',
  'app.box.detail.logs.action.2': '验证失败',
  'app.box.detail.edit.save': '保存',
  'app.box.detail.edit.networkMode': '联网方式',
  'app.box.detail.edit.wan': 'Wan参数',
  'app.box.detail.edit.ipAddr': 'IP地址',
  'app.box.detail.edit.ipAddr.message': 'IP地址不能为空',
  'app.box.detail.edit.subnetMask': '子网掩码',
  'app.box.detail.edit.subnetMask.message': '子网掩码不能为空',
  'app.box.detail.edit.gateway': '网关',
  'app.box.detail.edit.gateway.message': '网关不能为空',
  'app.box.detail.edit.dns1.message': 'DNS1不能为空',
  'app.box.detail.edit.wifi': 'WIFI参数',
  'app.box.detail.edit.scan': '扫描',
  'app.box.detail.edit.cellular': '蜂窝网络参数',
  'app.box.detail.edit.apn.message': 'APN不能为空',
  'app.box.detail.edit.userName': '用户名',
  'app.box.detail.edit.password': '密码',
  'app.box.detail.edit.dialing': '拨号号码',
  'app.box.detail.edit.connection': '连接参数',
  'app.box.detail.edit.mode': '连接模式',
  'app.box.detail.edit.mode.message': '请选择连接模式',
  'app.box.detail.edit.server': '登录域名',
  'app.box.detail.edit.server.message': '服务器地址不可为空',
  'app.box.detail.edit.mqttVersion': 'MQTT版本',
  'app.box.detail.edit.mqttVersion.message': '请选择MQTT版本',
  'app.box.detail.edit.connectTimeout': '超时时长',
  'app.box.detail.edit.connectTimeout.message': '超时时长不能为空',
  'app.box.detail.edit.keepAlive': 'Keep Alive',
  'app.box.detail.edit.keepAlive.message': 'Keep Alive不能为空',
  'app.box.detail.edit.cleansession': '清除会话',
  'app.box.detail.edit.certType': '证书类型',
  'app.box.detail.edit.caCrt': 'CA证书',
  'app.box.detail.edit.caCrt.message': 'CA证书不可为空',
  'app.box.detail.edit.clientCrt': '客户端证书',
  'app.box.detail.edit.clientCrt.message': '客户端证书不可为空',
  'app.box.detail.edit.clientKey': '客户端Key',
  'app.box.detail.edit.clientKey.message': '客户端Key不可为空',
  'app.box.detail.edit.time': '时钟服务器',
  'app.box.detail.edit.ntpserverType': '校时服务器(NTP)',
  'app.box.detail.edit.ntpserver': '服务器地址',
  'app.box.detail.edit.ntpserver.message': '服务器地址不能为空',
  'app.box.detail.edit.timezone': '时区(TimeZone)',
  'app.box.detail.edit.dateTime': '日期/时间',
  'app.box.detail.status.title': '设备状态',
  'app.box.detail.status.basicInfo': '基础信息',
  'app.box.detail.status.connectionState': '连接状态',
  'app.box.detail.status.networkType': '联网方式',
  'app.box.detail.status.boxType': '型号',
  'app.box.detail.status.softVer': '固件版本',
  'app.box.detail.status.boxNo': '序列号',
  'app.box.detail.status.userPassword': '密码',
  'app.box.detail.status.connection': '设备模式',
  'app.box.detail.status.wan': 'WAN参数',
  'app.box.detail.status.lan': 'LAN参数',
  'app.box.detail.status.gprs': 'GPRS参数',
  'app.box.detail.status.wifi': 'WIFI参数',
  'app.box.detail.status.ipAddr': 'IP地址',
  'app.box.detail.status.subnetMask': '子网掩码',
  'app.box.detail.status.gateway': '网关',
  'app.box.detail.status.dns1': 'DNS1',
  'app.box.detail.status.dns2': 'DNS2',
  'app.box.detail.status.lanIp': 'LAN IP',
  'app.box.detail.status.version': '文件版本',
  'app.box.detail.status.hardware': '硬件版本',
  'app.box.detail.status.fcs': 'FCS版本',
  'app.box.detail.status.boot': 'Boot版本',
  'app.box.detail.status.fds': 'FDS版本',
  'app.box.detail.status.kernel': '内核版本',
  'app.box.detail.status.fgui': 'FGUI版本',
  'app.box.detail.status.rootfs': '系统版本',
  'app.box.detail.status.floader': 'Floader版本',
  'app.box.detail.template.title': '条目配置',
  'app.box.detail.template.variable': '变量条目',
  'app.box.detail.template.alarm': '报警条目',
  'app.box.detail.template.macros': '边缘计算',
  'app.box.detail.template.transfer': 'MQTT转发',
  'app.box.detail.template.plc': 'PLC条目',
  'app.box.detail.template.variable.status': '状态',
  'app.box.detail.template.variable.status.msg': '请选择状态',
  'app.box.detail.template.variable.pushStatus': '监控点推送状态:',
  'app.box.detail.template.variable.readonly': '条目只写',
  'app.box.detail.template.variable.plc.msg': '请选择关联设备',
  'app.box.detail.template.variable.name.msg': '名称/备注',
  'app.box.detail.template.alarm.status': '状态',
  'app.box.detail.template.alarm.value': '报警值',
  'app.box.detail.template.alarm.pushStatus': '报警推送状态:',
  'app.box.list.title': 'FBox列表',
  'app.box.list.search': '搜索',
  'app.box.list.context.edit': '编辑',
  'app.box.list.context.favorite': '收藏',
  'app.box.list.context.delete': '删除',
  'app.box.list.context.export': '导出',
  'app.box.list.context.firmware': '更新固件',
  'app.box.list.context.template': '关联模板',
  'app.box.list.context.clean': '清除配置',
  'app.box.list.context.reboot': '重启',
  'app.box.list.context.reset': '恢复出厂',
  'app.box.list.context.sub': '操作',
  'app.box.mqtt.certType.0': 'CA签名证书',
  'app.box.mqtt.certType.1': '自签名证书',
  'app.box.networkMode.1': '以太网',
  'app.box.networkMode.2': 'WIFI',
  'app.box.networkMode.3': '蜂窝网络',
  'app.box.ipSource.0': 'DHCP',
  'app.box.ipSource.1': '静态IP地址',
  'app.box.job.index': '序号',
  'app.box.job.type': '任务类型',
  'app.box.job.type.1': '模板下发',
  'app.box.job.type.2': '固件升级',
  'app.box.job.type.3': '恢复出厂',
  'app.box.job.type.4': '设备升级',
  'app.box.job.boxNo': '序列号',
  'app.box.job.progress': '进度条',
  'app.box.job.message': '消息',
  'app.box.job.creationTime': '创建时间',
  'app.box.job.state.1': '正在下发',
  'app.box.job.state.2': '下发完成',
  'app.box.job.state.3': '下发失败',
  'app.box.upgrade.step.0': '开始进行升级',
  'app.box.upgrade.step.1': '获取设备固件信息',
  'app.box.upgrade.step.2': '获取设备PID',
  'app.box.upgrade.step.3': '下发升级程序',
  'app.box.upgrade.step.4': '等待重启设备',
  'app.box.upgrade.step.5': '获取升级固件',
  'app.box.upgrade.step.6': '获取固件依赖库',
  'app.box.upgrade.step.7': '校验文件信息',
  'app.box.upgrade.step.8': '正在下发固件',
  'app.box.upgrade.step.9': '等待设备重启',
  'app.box.upgrade.step.10': '升级完成',
  'app.box.upgrade.failed.title': '升级失败',
  'app.box.upgrade.failed.retry': '重试',
  'app.box.upgrade.failed.msg': '设备升级失败',
  'app.box.upgrade.boxTypeError': '设备类型错误',
  'app.template.prompt.delete': '确定要删除所选模板 {names}',
  'app.template.prompt.select': '请先勾选模板',
  'app.template.modalTitle': '创建设备',
  'app.template.edit.title': '编辑模板: ({name})',
  'app.template.edit.title.create': '创建模板',
  'app.template.edit.name': '模板名称',
  'app.template.edit.name.copy': '复制',
  'app.template.edit.name.message': '模板名称不能为空',
  'app.template.edit.remark': '备注',
  'app.template.toolbar.name.placeholder': '搜索模板名称',
  'app.template.toolbar.remark.placeholder': '搜索模板备注',
  'app.template.toolbar.clean': '清空',
  'app.template.toolbar.search': '搜索',
  'app.template.toolbar.import': '导入模板',
  'app.template.toolbar.create': '创建模板',
  'app.template.toolbar.batch': '批量操作',
  'app.template.toolbar.batch.delete': '批量删除',
  'app.template.toolbar.batch.export': '批量导出',
  'app.template.import.error.emptyName': '导入的模板名称不能为空',
  'app.template.import.error.format': '导入的模板格式不正确',
  'app.template.apply.title': '应用记录',
  'app.template.table.menu.copy': '复制',
  'app.template.table.menu.delete': '删除',
  'app.template.table.menu.export': '导出',
  'app.template.table.menu.edit': '编辑',
  'app.template.table.menu.applyRecord': '应用记录',
  'app.template.table.index': '序号',
  'app.template.table.name': '模板名称',
  'app.template.table.applied': '是否应用到FBox',
  'app.template.table.applied.true': '是',
  'app.template.table.applied.false': '否',
  'app.template.table.plcCount': '设备总数',
  'app.template.table.variableCount': '变量总数',
  'app.template.table.transferProtocol': '应用协议',
  'app.template.table.remark': '备注',
  'app.template.table.operation': '操作',
  'app.template.table.operation.config': '模板配置',
  'app.template.table.operation.apply': '应用',
  'app.template.tab.title': '模板配置',
  'app.template.tab.plcs': '设备配置',
  'app.template.tab.variables': '变量配置',
  'app.template.tab.alarm': '报警配置',
  'app.template.tab.macro': '边缘计算',
  'app.template.tab.transfers': '转发配置',
  'app.template.plc.existName': '设备名称已存在',
  'app.template.plc.toolbar.alias': '搜索设备名称',
  'app.template.plc.toolbar.plcName': '模糊搜索设备信息',
  'app.template.plc.toolbar.type': '通信类型',
  'app.template.plc.toolbar.clear': '清空',
  'app.template.plc.toolbar.search': '搜索',
  'app.template.plc.toolbar.create': '创建设备',
  'app.template.plc.toolbar.batchDelete': '批量删除',
  'app.template.plc.table.index': '序号',
  'app.template.plc.table.alias': '设备名称',
  'app.template.plc.table.plcName': '设备类型',
  'app.template.plc.table.communicationMode': '通信方式',
  'app.template.plc.table.operation': '操作',
  'app.template.plc.table.operation.edit': '编辑',
  'app.template.plc.table.operation.delete': '删除',
  'app.template.plc.edit.title': '编辑设备: ({name})',
  'app.template.plc.edit.type': '通信类型',
  'app.template.plc.edit.type.message': '请选择通信类型',
  'app.template.plc.edit.deviceMode': '设备模式',
  'app.template.plc.edit.deviceMode.message': '请选择设备模式',
  'app.template.plc.edit.manufacturer': '品牌',
  'app.template.plc.edit.manufacturer.message': '请选择品牌',
  'app.template.plc.edit.plcName': '设备类型',
  'app.template.plc.edit.plcName.message': '请选择PLC',
  'app.template.plc.edit.alias': '设备名称',
  'app.template.plc.edit.alias.message': '设备名称不可为空',
  'app.template.plc.edit.broadcastStationNo': '广播站号',
  'app.template.plc.edit.slaveStationNo': '服务器站号',
  'app.template.plc.edit.portNo': '端口',
  'app.template.plc.edit.workModel': '通讯类型',
  'app.template.plc.edit.baudRate': '波特率',
  'app.template.plc.edit.dataBits': '数据位',
  'app.template.plc.edit.stopBits': '停止位',
  'app.template.plc.edit.parity': '校验位',
  'app.template.plc.edit.compatibleModels': '兼容型号',
  'app.template.plc.edit.advance': '高级设置',
  'app.template.plc.edit.advance.package': '超时与组包参数',
  'app.template.plc.edit.autoPackage': '自动组包',
  'app.template.plc.edit.autoPackage.enable': '启用',
  'app.template.plc.edit.autoPackage.disable': '禁用',
  'app.template.plc.edit.plcResponceTimeout': '通讯超时时间',
  'app.template.plc.edit.protocolInterval': '通信时间间隔',
  'app.template.plc.edit.protocolTimeout1': '协议超时参数1',
  'app.template.plc.edit.protocolTimeout2': '协议超时参数2',
  'app.template.plc.edit.assembleIntervalBitReg': '组包位寄存器间隔',
  'app.template.plc.edit.assembleIntervalWordReg': '组包字寄存器间隔',
  'app.template.plc.edit.maxPacketsBitReg': '位组包最大寄存器个数',
  'app.template.plc.edit.maxPacketsWordReg': '字组包最大寄存器个数',
  'app.template.plc.edit.exceptions': '通信异常',
  'app.template.plc.edit.errMsgDispTime': '提醒信息显示时间',
  'app.template.plc.edit.byteOrder': '高低字、字节顺序',
  'app.template.plc.edit.byteOrder16': '16位整数',
  'app.template.plc.edit.byteOrder32': '32位整数',
  'app.template.plc.edit.byteOrderFloat': '32位浮点数',
  'app.template.plc.edit.references': '注：该设备已经被{refs}引用，请解除引用关系后编辑。',
  'app.template.variable.batchLimit': '批量个数范围{min}~{max}',
  'app.template.variable.existName': '变量名称已存在',
  'app.template.variable.plcEmpty': '设备列表不能为空，请先创建设备',
  'app.template.variable.edit.title': '编辑变量: ({name})',
  'app.template.variable.edit.title.batch': '批量创建变量',
  'app.template.variable.edit.name': '变量名称',
  'app.template.variable.edit.name.message': '变量名称不可为空',
  'app.template.variable.edit.deviceId': '关联设备',
  'app.template.variable.edit.stationNo': '站号',
  'app.template.variable.edit.dataType': '数据类型',
  'app.template.variable.edit.registerName': '地址类型',
  'app.template.variable.edit.registerName.message': '寄存器不可为空',
  'app.template.variable.edit.enabledIndex': '按位索引',
  'app.template.variable.edit.enabledIndex.desc': '使用字寄存器的按位索引',
  'app.template.variable.edit.enabledIndex.macroDesc': '(开启后不支持在边缘计算中引用)',
  'app.template.variable.edit.mainAddress': '地址',
  'app.template.variable.edit.subIndex': '地址块索引',
  'app.template.variable.edit.integerDigits': '整数位',
  'app.template.variable.edit.fractionDigits': '小数位',
  'app.template.variable.edit.fractionDigits.message': '小数位不可为空',
  'app.template.variable.edit.privilege': '读写设置',
  'app.template.variable.edit.encoding': '编码方式',
  'app.template.variable.edit.order': '高低字节互换',
  'app.template.variable.edit.format': '格式',
  'app.template.variable.edit.unit': '单位',
  'app.template.variable.edit.charCount': '字符个数',
  'app.template.variable.edit.batch': '批量设置',
  'app.template.variable.edit.batch.message': '增量类型不能为空',
  'app.template.variable.edit.batch.increment': '增量',
  'app.template.variable.edit.batch.increment.message': '增量不能为空',
  'app.template.variable.edit.batch.count': '批量个数',
  'app.template.variable.edit.batch.count.message': '个数不能为空',
  'app.template.variable.edit.valueTransform': '边缘换算',
  'app.template.variable.edit.valueTransform.0': '不启用',
  'app.template.variable.edit.valueTransform.1': '比例换算',
  'app.template.variable.edit.valueTransform.2': '缩放',
  'app.template.variable.edit.valueTransform.maxValue': '数值上限',
  'app.template.variable.edit.valueTransform.minValue': '数值下限',
  'app.template.variable.edit.valueTransform.scaleMaxValue': '比例上限',
  'app.template.variable.edit.valueTransform.scaleMinValue': '比例下限',
  'app.template.variable.edit.valueTransform.gain': '增益',
  'app.template.variable.edit.valueTransform.offset': '偏移量',
  'app.template.variable.edit.deadZone': '死区设置',
  'app.template.variable.edit.description': '备注',
  'app.template.variable.edit.references': '注：该变量已经被{refs}引用，请解除引用关系后编辑。',
  'app.template.variable.edit.references.macro': '解除【边缘计算】关联后， 请前往【边缘计算】修改脚本。',
  'app.template.variable.toolbar.name': '搜索变量名称',
  'app.template.variable.toolbar.description': '模糊搜索备注',
  'app.template.variable.toolbar.clear': '清空',
  'app.template.variable.toolbar.search': '搜索',
  'app.template.variable.toolbar.create': '创建变量',
  'app.template.variable.toolbar.create.batch': '批量创建',
  'app.template.variable.toolbar.batchDelete': '批量删除',
  'app.template.variable.table.index': '序号',
  'app.template.variable.table.name': '名称',
  'app.template.variable.table.deviceId': '关联设备',
  'app.template.variable.table.mainAddress': '地址',
  'app.template.variable.table.data': '实时数据',
  'app.template.variable.table.remark': '备注',
  'app.template.variable.table.operation': '操作',
  'app.template.variable.table.operation.edit': '编辑',
  'app.template.variable.table.operation.delete': '删除',
  'app.template.alarm.toolbar.name': '报警名称',
  'app.template.alarm.toolbar.clear': '清除',
  'app.template.alarm.toolbar.search': '搜索',
  'app.template.alarm.toolbar.create': '创建报警',
  'app.template.alarm.toolbar.batchDelete': '批量删除',
  'app.template.alarm.table.index': '序号',
  'app.template.alarm.table.name': '名称',
  'app.template.alarm.table.condition': '触发条件',
  'app.template.alarm.table.address': '地址',
  'app.template.alarm.table.msg': '内容',
  'app.template.alarm.table.operation': '操作',
  'app.template.alarm.table.operation.edit': '编辑',
  'app.template.alarm.table.operation.delete': '删除',
  'app.template.alarm.operator.0': 'OFF',
  'app.template.alarm.operator.1': 'ON',
  'app.template.alarm.condition.0': '不等于',
  'app.template.alarm.condition.1': '等于',
  'app.template.alarm.condition.2': '大于',
  'app.template.alarm.condition.3': '大于等于',
  'app.template.alarm.condition.4': '小于',
  'app.template.alarm.condition.5': '小于等于',
  'app.template.alarm.conditionMethod.0': '无',
  'app.template.alarm.conditionMethod.1': '与',
  'app.template.alarm.conditionMethod.2': '或',
  'app.template.alarm.value': '值',
  'app.template.alarm.existName': '报警名称重复',
  'app.template.alarm.edit.title': '编辑报警: ({name})',
  'app.template.alarm.edit.variableId': '变量条目',
  'app.template.alarm.edit.variableId.message': '变量不能为空',
  'app.template.alarm.edit.name': '报警名称',
  'app.template.alarm.edit.name.message': '报警名称不能为空',
  'app.template.alarm.edit.deadValue': '报警死区',
  'app.template.alarm.edit.msg': '报警内容',
  'app.template.alarm.edit.msg.message': '报警内容不能为空',
  'app.template.alarm.edit.references': ' 注：该报警已经被{refs}引用，请解除引用关系后编辑。',
  'app.template.macro.existName': '脚本名称已存在',
  'app.template.macro.table.index': '索引',
  'app.template.macro.table.name': '名称',
  'app.template.macro.table.description': '描述',
  'app.template.macro.table.operation': '操作',
  'app.template.macro.table.operation.edit': '编辑',
  'app.template.macro.table.operation.delete': '删除',
  'app.template.macro.toolbar.name': '脚本名称',
  'app.template.macro.toolbar.clear': '清除',
  'app.template.macro.toolbar.search': '搜索',
  'app.template.macro.toolbar.create': '创建脚本',
  'app.template.macro.toolbar.batchDelete': '批量删除',
  'app.template.macro.edit.title': '编辑脚本: ({name})',
  'app.template.macro.edit.name': '名称',
  'app.template.macro.edit.name.message': '名称不能为空',
  'app.template.macro.edit.description': '描述',
  'app.template.macro.edit.saveClose': '保存&关闭',
  'app.template.macro.edit.save': '保存',
  'app.template.macro.edit.save.message': '有未保存的内容，是否放弃当前修改的内容？',
  'app.template.macro.edit.help': '帮助',
  'app.template.macro.edit.docTitle': '函数帮助',
  'app.template.macro.editor.output': '输出',
  'app.template.macro.editor.watch': '监视',
  'app.template.macro.editor.variable': '变量名',
  'app.template.macro.editor.offset': '偏移量',
  'app.template.macro.editor.value': '值',
  'app.template.macro.plan': '执行计划',
  'app.template.macro.plan.title': '设置执行计划',
  'app.template.macro.plan.mode': '执行模式',
  'app.template.macro.plan.mode.0': 'FBox启动时执行',
  'app.template.macro.plan.mode.1': '周期执行',
  'app.template.macro.plan.mode.2': '条件执行',
  'app.template.macro.plan.cycle': '执行周期',
  'app.template.macro.plan.variable': '变量条目',
  'app.template.macro.plan.variable.message': '变量不能为空',
  'app.template.macro.plan.condition': '条件',
  'app.template.macro.plan.condition.message': '条件不能为空',
  'app.template.macro.variable.contact': '关联变量',
  'app.template.macro.variable.title': '请选择变量',
  'app.template.transfer.config.create': '新增',
  'app.template.transfer.config.combination': '组合方式',
  'app.template.transfer.config.combination.title': '创建组合方式',
  'app.template.transfer.config.combination.title.edit': '编辑组合方式: ({name})',
  'app.template.transfer.config.combination.name': '名称',
  'app.template.transfer.config.combination.name.message': '名称不可为空',
  'app.template.transfer.config.combination.format': '格式',
  'app.template.transfer.config.combination.format.message': '格式不可为空',
  'app.template.transfer.config.combination.format.preview': '预览',
  'app.template.transfer.config.combination.description': '描述',
  'app.template.transfer.config.combination.operation': '操作',
  'app.template.transfer.config.combination.operation.edit': '编辑',
  'app.template.transfer.config.combination.operation.delete': '删除',
  'app.template.transfer.config.combination.delete.message': '删除后不可恢复，你还要继续吗？',
  'app.template.transfer.config.timestamp': '时间格式',
  'app.template.transfer.config.timestamp.title': '创建时间格式',
  'app.template.transfer.config.timestamp.title.edit': '编辑时间格式: ({name})',
  'app.template.transfer.config.timestamp.name': '名称',
  'app.template.transfer.config.timestamp.name.message': '名称不可为空',
  'app.template.transfer.config.timestamp.format': '格式',
  'app.template.transfer.config.timestamp.format.message': '格式不可为空',
  'app.template.transfer.config.timestamp.zone': '时区',
  'app.template.transfer.config.timestamp.zone.message': '时区不可为空',
  'app.template.transfer.config.timestamp.description': '描述',
  'app.template.transfer.config.timestamp.format.preview': '预览',
  'app.template.transfer.config.timestamp.operation': '操作',
  'app.template.transfer.config.timestamp.operation.edit': '编辑',
  'app.template.transfer.config.timestamp.operation.delete': '删除',
  'app.template.transfer.protocol.name': '连接名称',
  'app.template.transfer.protocol.name.message': '连接名称不能为空',
  'app.template.transfer.protocol.name.exists': '连接名称已经存在',
  'app.template.transfer.protocol.serverUrl': '服务器地址',
  'app.template.transfer.protocol.serverUrl.message': '服务器地址不能为空',
  'app.template.transfer.protocol.serverPort': '服务器端口',
  'app.template.transfer.protocol.serverPort.message': '服务器端口不能为空',
  'app.template.transfer.protocol.serverPath': 'Path',
  'app.template.transfer.protocol.serverPath.message': '服务路径不可为空',
  'app.template.transfer.protocol.clientId': 'ClientId',
  'app.template.transfer.protocol.clientId.message': 'ClientId不能为空',
  'app.template.transfer.protocol.clientId.exists': 'ClientId不能重复',
  'app.template.transfer.protocol.mqttVersion': 'MQTT版本',
  'app.template.transfer.protocol.mqttVersion.message': '请选择MQTT版本',
  'app.template.transfer.protocol.keepAlive': 'KeepAlive',
  'app.template.transfer.protocol.keepAlive.message': 'KeepAlive时间不能为空',
  'app.template.transfer.protocol.pubMode': '推送方式',
  'app.template.transfer.protocol.pubMode.message': '请选择推送方式',
  'app.template.transfer.protocol.pubInterval': '推送周期',
  'app.template.transfer.protocol.pubInterval.message': '推送周期不能为空',
  'app.template.transfer.protocol.withAuthen': '用户验证',
  'app.template.transfer.protocol.username': '用户名',
  'app.template.transfer.protocol.username.message': '用户名不能为空',
  'app.template.transfer.protocol.password': '密码',
  'app.template.transfer.protocol.password.message': '密码不能为空',
  'app.template.transfer.protocol.connectionType': '连接方式',
  'app.template.transfer.protocol.clientCrt': '客户端证书',
  'app.template.transfer.protocol.caCrt': 'CA证书',
  'app.template.transfer.protocol.clientKey': '客户端密钥',
  'app.template.transfer.protocol.timestamp': '时间格式',
  'app.template.transfer.protocol.offlineCaching': '离线缓存',
  'app.template.transfer.protocol.store': '存储方式',
  'app.template.transfer.protocol.store.message': '请选择存储方式',
  'app.template.transfer.protocol.cacheTime': '上报时间',
  'app.template.transfer.protocol.cacheTime.message': '上报时间不能为空',
  'app.template.transfer.protocol.cacheGetTime': '采样间隔',
  'app.template.transfer.protocol.cacheGetTime.message': '采样间隔不能为空',
  'app.template.transfer.protocol.edit': '编辑',
  'app.template.transfer.protocol.copy': '复制',
  'app.template.transfer.protocol.delete': '删除',
  'app.template.transfer.protocol.enable': '启用',
  'app.template.transfer.protocol.enable.true': '停用',
  'app.template.transfer.protocol.enable.false': '启用',
  'app.template.transfer.protocol.create': '创建连接',
  'app.template.transfer.protocol.create.edit': '编辑连接: ({name})',
  'app.template.transfer.protocol.general': '常规配置',
  'app.template.transfer.protocol.verification': '用户验证',
  'app.template.transfer.protocol.connection': '连接模式',
  'app.template.transfer.protocol.other': '其它配置',
  'app.template.transfer.protocol.compression': '报文压缩',
  'app.template.transfer.protocol.compress': '开启压缩',
  'app.template.transfer.protocol.compress.type': '压缩算法',
  'app.template.transfer.connection.search': '搜索',
  'app.template.transfer.connection.search.clean': '清空',
  'app.template.transfer.connection.search.name': '搜索配置名称',
  'app.template.transfer.connection.search.function': '请选择功能名称',
  'app.template.transfer.connection.create': '创建配置',
  'app.template.transfer.connection.create.edit': '编辑配置: ({name})',
  'app.template.transfer.connection.index': '序号',
  'app.template.transfer.connection.name': '配置名称',
  'app.template.transfer.connection.name.message': '配置名称不能为空',
  'app.template.transfer.connection.function': '功能',
  'app.template.transfer.connection.function.message': '请选择功能',
  'app.template.transfer.connection.alarmEvent': '关联报警点',
  'app.template.transfer.connection.alarmEvent.message': '关联报警点不能为空',
  'app.template.transfer.connection.alarmEvent.time': '时间',
  'app.template.transfer.connection.alarmEvent.time.message': '时间不能为空',
  'app.template.transfer.connection.alarmEvent.before': '前',
  'app.template.transfer.connection.alarmEvent.after': '后',
  'app.template.transfer.connection.alarmEvent.unit': '秒',
  'app.template.transfer.connection.operation': '操作',
  'app.template.transfer.connection.operation.edit': '编辑',
  'app.template.transfer.connection.operation.delete': '删除',
  'app.template.transfer.connection.pub': '发布',
  'app.template.transfer.connection.sub': '订阅',
  'app.template.transfer.connection.variable.name': '名称',
  'app.template.transfer.connection.variable.dataType': '类型',
  'app.template.transfer.connection.variable.description': '描述',
  'app.template.transfer.connection.variable.privilege': '读写类型',
  'app.template.transfer.connection.variable.contact': '关联变量',
  'app.template.transfer.connection.variable.internal': '内部变量',
  'app.template.transfer.connection.variable.item': '监控点',
  'app.template.transfer.connection.variable.item.alarm': '报警点',
  'app.template.transfer.connection.variable.combination': '组合方式',
  'app.template.transfer.connection.alarm.name': '报警名称',
  'app.template.transfer.connection.alarm.dataType': '数据类型',
  'app.template.transfer.connection.alarm.msg': '消息内容',
  'app.template.transfer.connection.editableTable.anonymousName': 'MQTT变量名称',
  'app.template.transfer.connection.editableTable.valueType': '数据类型',
  'app.template.transfer.connection.editableTable.variableName': '变量名称',
  'app.template.transfer.connection.editableTable.defaultValue': '默认值',
  'app.template.transfer.connection.editableTable.operation': '操作',
  'app.template.transfer.connection.editableTable.topic': '主题(Topic)',
  'app.template.transfer.connection.editableTable.create': '新增变量',
  'app.template.transfer.connection.editableTable.import': '导入变量',
  'app.template.transfer.connection.editableTable.cacheTopic': '缓存Topic',
  'app.template.transfer.table.index': '序号',
  'app.template.transfer.table.name': '配置名称',
  'app.template.transfer.table.host': '服务器地址',
  'app.template.transfer.table.pubMode': '推送方式',
  'app.template.transfer.table.enable': '是否启用',
  'app.template.code.0': '下发成功',
  'app.template.code.1': '下发超时',
  'app.template.code.2': '系统异常',
  'app.template.code.1001': '固件不支持PLC特性',
  'app.template.code.1002': '固件不支持变量特性',
  'app.template.code.1003': '固件不支持数据转发特性',
  'app.template.code.1004': '固件不支持固件升级特性',
  'app.template.code.1005': '固件不支持网络设置特性',
  'app.template.code.1006': '固件不支持时钟设置特性',
  'app.template.code.1007': '固件不支持APN设置特性',
  'app.template.code.1008': '固件不支持连接配置特性',
  'app.template.code.1009': '固件不支持VPN特性',
  'app.template.code.1010': '固件不支持报警特性',
  'app.template.code.1011': '固件不支持边缘计算特性',
  'app.template.code.10011': 'plc驱动下载失败',
  'app.template.code.10012': 'plc驱动更新失败',
  'app.template.code.10013': 'plc下载url地址错误',
  'app.template.code.10014': 'plc保存配置文件错误',
  'app.template.code.10015': 'plc未知设备模式',
  'app.template.code.20001': '注册监控点失败',
  'app.template.code.20002': '初始化plc配置文件失败',
  'app.template.code.30001': '北向MQTT配置文件错误',
  'app.template.code.30002': '保存北向配置文件失败',
  'app.template.code.40001': '执行重启命令失败',
  'app.template.code.40002': '未知错误命令',
  'app.template.code.40003': '命令json格式为空',
  'app.template.code.40004': '打开json失败',
  'app.template.code.40005': '开启监控点推送失败',
  'app.template.code.50001': '固件未知类型',
  'app.template.code.50002': '固件下载失败',
  'app.template.code.50003': '固件文件MD5检查错误',
  'app.template.code.50004': '固件文件打开失败',
  'app.template.code.50005': '固件文件未知解压类型',
  'app.template.code.50006': '固件文件授权检查失败',
  'app.template.code.60001': '获取盒子基本信息配置文件错误',
  'app.template.code.60002': '盒子基本信息配置文件保存失败',
  'app.template.code.80001': 'Json协议解析失败',
  'app.template.code.80002': '保存Json文件失败',
  'app.template.code.80003': '配置文件读取失败',
  'app.template.code.80004': '配置文件写入失败',
  'app.template.code.90001': '写监控点下发json格式失败',
  'app.template.code.90002': '写监控点中设备获取监控点id失败',
  'app.template.code.90003': '写监控点数据失败',
  'app.template.code.100001': '开启VPN连接失败',
  'app.template.code.100002': '断开VPN连接失败',
  'app.template.code.100003': '设备与plc连接失败',
  'app.template.code.100004': 'VPN连接库地址无效',
  'app.template.code.100005': 'VPN连接库MD5错误',
  'app.template.code.110001': '报警监控点注册失败',
  'app.template.reference.objectType': '引用类型',
  'app.template.reference.objectType.0': '设备配置',
  'app.template.reference.objectType.1': '变量配置',
  'app.template.reference.objectType.2': '报警配置',
  'app.template.reference.objectType.3': '边缘计算',
  'app.template.reference.objectType.4': '转发配置',
  'app.template.reference.objectType.5': '边缘计算执行条件',
  'app.template.reference.view': '查看引用',
  'app.firmware.table.index': '序号',
  'app.firmware.table.mainVer': '版本号',
  'app.firmware.table.verDetail': '版本信息',
  'app.firmware.table.boxTypes': '支持设备',
  'app.firmware.table.remark': '备注',
  'app.drive.table.index': '序号',
  'app.drive.table.manufacturer': '厂商',
  'app.drive.table.type': '类型',
  'app.drive.table.deviceMode': '模式',
  'app.drive.table.plcName': '名称',
  'app.server.edit.type': '服务器类型',
  'app.server.edit.type.message': '必须选择服务器类型',
  'app.server.edit.apiUrl': 'API服务地址',
  'app.server.edit.apiUrl.message': 'API地址不可为空',
  'app.server.edit.apiVersion': 'API版本',
  'app.server.edit.apiVersion.message': 'API版本不可为空',
  'app.server.edit.appId': 'AppID',
  'app.server.edit.appId.message': 'AppID不可为空',
  'app.server.edit.appSecret': 'AppSecret',
  'app.server.edit.appSecret.message': 'AppSecret不可为空',
  'app.server.edit.mqttAddress': 'MQTT服务地址',
  'app.server.edit.mqttAddress.message': 'MQTT服务地址不可为空',
  'app.server.edit.save': '保存',
  'app.user.table.index': '序号',
  'app.user.table.userName': '用户名',
  'app.user.table.userName.placeholder': '请输入用户名',
  'app.user.table.userName.message': '用户名仅支持字母数字下划线',
  'app.user.table.password': '密码',
  'app.user.table.password.placeholder': '请输入密码',
  'app.user.table.password.message.number': '至少包含一个数字',
  'app.user.table.password.message.uppercase': '至少包含一个大写字母',
  'app.user.table.password.message.lowercase': '至少包含一个小写字母',
  'app.user.table.password.message.special': '至少包含一个特殊字符',
  'app.user.table.email': 'Email',
  'app.user.table.email.placeholder': '请输入邮箱',
  'app.user.table.email.message': '邮箱格式不正确',
  'app.user.table.roles': '角色',
  'app.user.table.roles.placeholder': '请选择角色',
  'app.user.table.roles.message': '角色不能为空',
  'app.user.table.lockoutEnabled': '启用锁定',
  'app.user.table.operation': '操作',
  'app.user.table.operation.delete': '删除',
  'app.user.toolbar.create': '添加新用户',
  'app.user.confirm.delete': '确定要删除该用户以及该用户下的所有数据？此过程不可恢复！',
  'app.system.register.name': '名称',
  'app.system.register.name.placeholder': '请输入名称',
  'app.system.register.address': '地址',
  'app.system.register.dataWidth': '位宽',
  'app.system.register.description': '描述',
  'app.system.register.search': '查询',
  'app.connectionState.0': '未知',
  'app.connectionState.1': '在线',
  'app.connectionState.2': '超时',
  'app.connectionState.3': '离线',
  'app.boxType.0': 'FBox',
  'app.boxType.1': 'FBox-Mini',
  'app.boxType.2': 'FBox-Lite',
  'app.boxType.3': 'FBox-Vpn',
  'app.boxType.4': 'FBox-Lite',
  'app.boxType.5': 'FLink',
  'app.boxType.6': 'FL3',
  'app.boxType.7': 'FBox-Lite',
  'app.boxType.8': 'HMI',
  'app.boxType.16': 'NBIot',
  'app.subType.1': 'Ethernet',
  'app.subType.2': '2G',
  'app.subType.3': '3G',
  'app.subType.4': 'WIFI',
  'app.subType.5': '4G',
  'app.subType.7': '4G',
  'app.subType.8': '5G',
  'app.networkType.0': '未知',
  'app.networkType.1': '以太网',
  'app.networkType.2': '2G',
  'app.networkType.3': '3G',
  'app.networkType.4': 'Wifi',
  'app.networkType.5': '4G',
  'app.templateState.0': '未下发',
  'app.templateState.1': '正在下发',
  'app.templateState.2': '下发完成',
  'app.templateState.3': '下发失败',
  'app.template.progress.status.0': 'normal',
  'app.template.progress.status.1': 'active',
  'app.template.progress.status.2': 'success',
  'app.template.progress.status.3': 'exception',
  'app.parity.0': '无校验',
  'app.parity.1': '奇校验',
  'app.parity.2': '偶校验',
  'app.portNo.0': 'COM1',
  'app.portNo.1': 'COM2',
  'app.portNo.2': 'COM3',
  'app.deviceMode.0': '主模式',
  'app.deviceMode.1': '从模式',
  'app.plcType.serial': '串口',
  'app.plcType.ethernet': '网络',
  'app.plcType.local': 'Local',
  'app.plcStatus': '读取中',
  'app.plcStatus.offline': '盒子不在线',
  'app.plcStatus.0': '正常',
  'app.plcStatus.1': '超时',
  'app.plcStatus.2': '异常',
  'app.alarmStatus.0': '正常',
  'app.alarmStatus.1': '触发',
  'app.communicationMode.local': '无',
  'app.dataType.0': '位',
  'app.dataType.1': '16位无符号',
  'app.dataType.2': '16位有符号',
  'app.dataType.3': '16位BCD',
  'app.dataType.4': '16位16进制',
  'app.dataType.5': '16位二进制',
  'app.dataType.11': '32位无符号',
  'app.dataType.12': '32位有符号',
  'app.dataType.13': '32位BCD',
  'app.dataType.14': '32位16进制',
  'app.dataType.15': '32位二进制',
  'app.dataType.16': '单精度浮点',
  'app.dataType.30': '字符串',
  'app.dataType.999': 'long,string',
  'app.dataType.998': 'int,string',
  'app.dataType.997': 'uint,string',
  'app.dataType.996': 'float,string',
  'app.dataType.995': 'string',
  'app.dataType.994': 'uint',
  'app.dataType.993': 'int',
  'app.dataType.992': 'boolean',
  'app.dataType.991': 'string,int',
  'app.privilege.2': '只写',
  'app.privilege.4': '只读',
  'app.privilege.6': '读写',
  'app.protocol.mqtt': 'MQTT',
  'app.protocol.mqtt.internal': '内置协议',
  'app.protocol.mqtt.flexem': '繁易',
  'app.mqtt.pubMode.interval': '周期推送',
  'app.mqtt.pubMode.changed': '变化推送',
  'app.mqtt.connectionType.raw_tcp': 'TCP连接',
  'app.mqtt.connectionType.secure_tcp': 'TCP加密连接',
  'app.mqtt.connectionType.raw_websocket': 'Websocket连接',
  'app.mqtt.connectionType.secure_websocket': 'Websocket加密连接',
  'app.mqtt.connectionType.local': '本地',
  'app.mqtt.connectionType.sd': 'SD卡',
  'app.mqtt.connectionType.usb': 'U盘',
  'app.mqtt.function.PushMonitorData': '发布监控点数据',
  'app.mqtt.function.PushAlarm': '发布FBox报警',
  'app.mqtt.function.WriteItem': '写监控点数据',
  'app.mqtt.function.Suspend': '暂停或开启监控点推送',
  'app.mqtt.function.SetReboot': '重启网关',
  'app.mqtt.function.SetPushMethod': '设置监控点上报行为',
  'app.mqtt.function.ReadItem': '立即获取监控点数据',
  'app.mqtt.function.GetFBoxInfo': '获取FBox信息',
  'app.mqtt.function.GetPicture': '图片抓拍',
  'app.mqtt.function.PushRegisterMsg': '发布设备注册信息',
  'app.mqtt.function.PushAlarmEvent': '发布报警监听数据',
  'app.mqtt.variable.flexem_timestamp.desc': '时间戳,MQTT客户端在与服务器交互是必须带有时间戳,用于确定数据收发的时间点',
  'app.mqtt.variable.flexem_message_id.desc': '客户自定义数值字段,返回时会原样返回该数值',
  'app.mqtt.variable.flexem_alarm.desc': '报警触发类型("alarm"-触发报警,"restore"-报警恢复)',
  'app.mqtt.variable.flexem_message.desc': '操作后返回状态的文字描述',
  'app.mqtt.variable.flexem_error_code.desc': '操作后返回的状态码',
  'app.mqtt.variable.gy_deviceId.desc': '根云定义的设备的id号,取写监控点回复主题的后三部分名称',
  'app.mqtt.variable.gy_error_code.desc': '根云定义的错误码,字符串类型',
  'app.mqtt.variable.flexem_info_type.desc': 'FBox发布的信息类型,"location"表示发布的是位置信息,"status"表示发布的是状态信息',
  'app.mqtt.variable.flexem_sim_lac.desc': '基站-位置区域码',
  'app.mqtt.variable.flexem_sim_cel.desc': '基站-基站编号',
  'app.mqtt.variable.flexem_sim_mcc.desc': '基站-移动国家代码',
  'app.mqtt.variable.flexem_sim_mnc.desc': '基站-移动网络号码',
  'app.mqtt.variable.flexem_sim_ccid.desc': 'ICCID',
  'app.mqtt.variable.flexem_longitude.desc': 'GPS信息-经度信息',
  'app.mqtt.variable.flexem_latitude.desc': 'GPS信息-纬度信息',
  'app.mqtt.variable.flexem_push_interval.desc': '该数据段表示需要设置监控点数据的发布周期',
  'app.mqtt.variable.flexem_push_mode.desc': '数据推送方式("interval":周期推送,"change":变化推送)',
  'app.mqtt.variable.flexem_pause.desc': '该数据段表示是否暂停当前FBox向MQTT服务器的数据推送',
  'app.mqtt.variable.flexem_fcs_ver.desc': '该数据段表示FBox内Fcs的代码版本',
  'app.mqtt.variable.flexem_floader_ver.desc': '该数据段表示FBox内Floader的代码版本',
  'app.mqtt.variable.flexem_fds_ver.desc': '该数据段表示FBox内Fds的代码版本',
  'app.mqtt.variable.flexem_mqtt_ver.desc': '该数据段表示FBox内MQTT的代码版本',
  'app.mqtt.variable.flexem_sn.desc': 'FBox/HMI的序列号',
  'app.mqtt.variable.flexem_password.desc': 'FBox/HMI的密码',
  'app.mqtt.variable.flexem_online_sta.desc': 'FBox在线状态',
  'app.mqtt.variable.flexem_net_type.desc': 'FBox联网类型',
  'app.mqtt.variable.flexem_wireless.desc': '盒子无线信号强度',
  'app.mqtt.variable.flexem_vnc_op_password.desc': 'VNC操控密码',
  'app.mqtt.variable.flexem_vnc_mo_password.desc': 'VNC监控密码',
  'app.mqtt.variable.flexem_connect_sta.desc': '网络连接状态',
  'app.mqtt.variable.flexem_sd_card_sta.desc': 'SD卡插入状态',
  'app.mqtt.variable.flexem_usb_sta.desc': 'U盘插入状态',
  'app.mqtt.variable.flexem_usb_down_line_sta.desc': 'USB下载线连接状态',
  'app.mqtt.variable.flexem_picture_base64.desc': '图片的信息,以base64格式发送',
  'app.mqtt.variable.flexem_reboot.desc': '该数据段表示是否重启FBox',
  'app.mqtt.variable.flexem_push_alarm.desc': '该数据段表示是否启用报警点信息上报功能',
  'app.mqtt.variable.flexem_get_all_items.desc': '立即获取监控点数据上报到MQTT',
  'app.mqtt.variable.flexem_get_info.desc': '该数据段表示需要获取盒子的一些状态信息("location"获取位置信息,"status"获取状态信息)',
  'app.mqtt.variable.flexem_uuid.desc': '设备主动上报的uuid字段,注册成功后服务器原样返回',
  'app.mqtt.platform.flexem': '繁易',
  'app.mqtt.platform.ali_plat': '阿里',
  'app.mqtt.platform.huawei_plat': '华为',
  'app.mqtt.platform.onenet_plat': 'OneNet',
  'app.mqtt.platform.tencent_plat': '腾讯',
  'app.modal.ok': '确定',
  'app.modal.cancel': '取消',
  'app.modal.save': '保存',
  'app.modal.abandon': '放弃',
  'app.modal.import': '导入',
  'app.modal.confirm.delete': '确定要删除此项吗',
  'app.modal.confirm.delete.forbidden': '不可删除此项',
  'app.modal.confirm.edit.forbidden': '不可编辑此项',
  'app.modal.reboot.confirm': '配置修改成功，需要重启设备才能生效，确定重启？',
  'app.modal.reboot.countDown': '设备重启中，请于 {second} 秒后操作。',
  'app.modal.reboot.message': '设备正在重启中...',
  'app.modal.title': '系统提示',
  'app.device.code.unknown': '未知的错误',
  'app.device.code.0': '完成',
  'app.device.code.1': '下发指令超时',
  'app.device.code.2': '系统错误',
  'app.device.code.3': '磁盘空间不足',
  'app.device.code.4': '命令执行失败',
  'app.device.code.5': '设备未连接',
  'app.device.code.6': 'JSON解析失败',
  'app.device.code.7': '文件MD5验证失败',
  'app.device.code.101': 'usb打开失败',
  'app.device.code.102': 'usb打开失败',
  'app.device.code.103': '数据写入失败',
  'app.device.code.104': '数据读取失败',
  'app.device.code.105': '数据解析失败',
  'app.device.code.106': '命令被禁止执行',
  'app.device.code.107': '命令执行失败',
  'app.device.code.108': '命令执行失败',
  'app.device.code.109': '命令未实现',
  'app.device.code.110': '连接失败',
  'app.device.code.1001': '固件不支持PLC特性',
  'app.device.code.1002': '固件不支持变量特性',
  'app.device.code.1003': '固件不支持MQTT转发特性',
  'app.device.code.1004': '固件不支持升级',
  'app.device.code.1005': '固件不支持网络设置',
  'app.device.code.1006': '固件不支持NTP配置',
  'app.device.code.1007': '固件不支持APN配置',
  'app.device.code.1008': '固件不支持连接配置',
  'app.device.code.1009': '固件不支持VPN特性',
  'app.device.code.1010': '固件不支持报警特性',
  'app.device.code.1011': '固件不支持边缘计算特性',
  'app.device.code.9000': 'connect.mode文件不存在',
  'app.device.code.9001': '读取connect.mode文件失败',
  'app.device.code.9002': '当前模式为Manger，不支持SE指令',
  'app.device.code.9003': '文件传输超时',
  'app.device.code.9004': '下载文件MD5错误',
  'app.device.code.9005': '文件无效或不存在',
  'app.device.code.9006': '设备申请文件内存空间失败',
  'app.device.code.10011': 'plc驱动下载失败',
  'app.device.code.10012': 'plc驱动更新失败',
  'app.device.code.10013': 'plc下载url地址错误',
  'app.device.code.10014': 'plc保存配置文件错误',
  'app.device.code.10015': 'plc未知设备模式',
  'app.device.code.20001': '注册监控点失败',
  'app.device.code.20002': '初始化plc配置文件失败',
  'app.device.code.30001': '北向MQTT配置文件错误',
  'app.device.code.30002': '保存北向配置文件失败',
  'app.device.code.40001': '执行重启命令失败',
  'app.device.code.40002': '未知错误命令',
  'app.device.code.40003': '命令json格式为空',
  'app.device.code.50001': '固件未知类型',
  'app.device.code.50002': '固件下载失败',
  'app.device.code.50003': '固件文件MD5检查错误',
  'app.device.code.50004': '固件文件打开失败',
  'app.device.code.50005': '固件文件未知解压类型',
  'app.device.code.50006': '固件文件授权检查失败',
  'app.device.code.60001': '获取盒子基本信息配置文件错误',
  'app.device.code.60002': '盒子基本信息配置文件保存失败',
  'app.device.code.80001': 'Json协议解析失败',
  'app.device.code.80002': '保存Json文件失败',
  'app.device.code.80003': '配置文件读取失败',
  'app.device.code.80004': '配置文件写入失败',
  'app.device.code.90001': '写监控点下发json格式失败',
  'app.device.code.90002': '写监控点中设备获取监控点id失败',
  'app.device.code.90003': '写监控点数据失败',
  'app.device.code.100001': '开启VPN连接失败',
  'app.device.code.100002': '断开VPN连接失败',
  'app.device.code.100003': '设备与plc连接失败',
  'app.device.code.100004': 'VPN连接库地址无效',
  'app.device.code.100005': 'VPN连接库MD5错误',
  'app.device.code.110001': '报警监控点注册失败',
  'app.device.code.10000000': '无效的参数',
  'app.device.code.10000001': '系统初始化信息异常',
  'app.device.code.10000002': 'MQTT连接无效',
  'app.device.code.10000003': '请求的数据不存在',
  'app.device.code.10000004': '名称已存在',
  'app.device.code.10000005': '没有访问权限',
  'app.device.code.10000006': '命令执行失败',
  'app.device.code.10000007': '系统错误',
  'app.device.code.10000008': 'USB未连接',
  'app.device.code.10000009': 'JSON解析失败',
  'app.device.code.10001000': '此设备和: {boxNo}重复.',
  'app.device.code.10001001': '序列号为: {boxNo}的设备已被其他用户添加',
  'app.device.code.10001002': '设备不存在',
  'app.device.code.10001003': '设备不在线',
  'app.device.code.10001004': '设备固件升级中',
  'app.device.code.10001005': '设备固件不支持',
  'app.device.code.10001006': '设备正在恢复出厂中',
  'app.device.code.10001007': '设备配置不支持',
  'app.device.code.10001008': '设备Floader版本不支持',
  'app.device.code.10001009': '设备模式不支持',
  'app.device.code.10001010': '设备类型不支持',
  'app.device.code.10001011': '设备忙碌中，请稍后再试',
  'app.device.code.10001012': '批量升级仅支持同类型设备。',
  'app.device.code.10001100': '设备固件不支持此特性',
  'app.device.code.10001200': '设备网络参数为空',
  'app.device.code.10001201': '设备信息为空',
  'app.device.code.10001202': '设备驱动或固件文件未找到',
  'app.device.code.10002000': '模板应用错误',
  'app.device.code.10002001': '设备: {boxNo} 正在应用中, 请稍后...',
  'app.device.code.10002002': '模板: {name} 名称已存在',
  'app.device.code.10002003': '模板不存在',
  'app.device.code.10002004': '模板PLC不能为空',
  'app.device.code.10002005': '模板变量不能为空',
  'app.device.code.10003000': '用户不存在',
  'app.device.code.10003001': '当前用户不能删除自己',
  'app.device.code.10003002': '修改的密码不能为空',
  'app.device.code.10003003': 'App名称不能为空',
  'app.device.code.10003004': 'App不存在',
  'app.device.code.10003005': '无法删除内置管理员账号',
  'app.device.code.10003006': '用户创建失败',
  'app.device.code.10003007': '修改密码失败',
  'app.device.code.10003008': '用户名已存在',
  'app.device.code.10003009': '该用户下存在使用数据，无法删除',
  'app.device.code.10004000': '服务器内部异常',
  'app.device.code.10004005': 'VPN成员数量超过限制',
  'app.device.code.10004006': '创建VPN网络失败',
  'app.device.code.10004007': '创建VPN成员失败',
  'app.device.code.10004008': 'VPN接口调用异常',
  'app.device.code.10004009': '开启VPN透传失败',
  'app.device.code.10004010': '关闭VPN透传失败',
  'app.device.code.10004011': '当前密钥不支持获取固件升级信息，请联系管理员重新申请',
  'app.device.code.10004012': '当前密钥不支持获取PLC信息，请联系管理员重新申请',
  'app.device.code.10004013': '当前密钥不支持Vpn功能，请联系管理员重新申请',
  'app.device.code.10004014': '无效的设备',
  'app.device.code.10004015': 'VPN依赖文件缺失',
  'app.device.code.10004016': '设备认证失败',
  'app.device.code.10004017': '请求频率过快，请求受限',
  'app.device.code.10004018': '驱动文件未找到',
  'app.device.code.10004019': '设备固件文件未找到',
  'app.device.code.10005000': 'PMS服务调用异常',
  'app.device.code.10005001': '设备信息未找到',
  'app.device.code.10005002': 'PMS服务器返回数据异常',
}
